(function () {
  "use strict";

  var STORAGE_KEY = "theartfolio_moods";
  var MOODS = [
    { id: "calm", label: "Calm", hint: "Steady · cool" },
    { id: "quiet", label: "Quiet", hint: "Soft · still" },
    { id: "soft", label: "Soft", hint: "Gentle · light" },
    { id: "warm", label: "Warm", hint: "Earth · glow" },
    { id: "moody", label: "Moody", hint: "Brooding · dusk" },
    { id: "dramatic", label: "Dramatic", hint: "Contrast · scale" },
    { id: "atmospheric", label: "Atmospheric", hint: "Mist · haze" },
    { id: "nostalgic", label: "Nostalgic", hint: "Memory · time" },
    { id: "contemplative", label: "Contemplative", hint: "Still · thought" },
    { id: "minimal", label: "Minimal", hint: "Spare · form" },
    { id: "vibrant", label: "Vibrant", hint: "Colour · punch" },
    { id: "energetic", label: "Energetic", hint: "Bold · lively" }
  ];

  var storageUsable = false;

  function testStorage() {
    try {
      var probe = STORAGE_KEY + "_probe";
      localStorage.setItem(probe, "1");
      localStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  }

  function cleanId(id) {
    return String(id == null ? "" : id).trim();
  }

  function getAllMoods() {
    if (!storageUsable) return {};
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      if (!parsed || Array.isArray(parsed) || typeof parsed !== "object") return {};
      return parsed;
    } catch (error) {
      return {};
    }
  }

  function writeMoods(map) {
    if (!storageUsable) return false;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
      return true;
    } catch (error) {
      return false;
    }
  }

  function getMood(id) {
    return getAllMoods()[cleanId(id)] || null;
  }

  function setMood(id, mood) {
    id = cleanId(id);
    if (!id) return false;
    var map = getAllMoods();
    if (!mood) delete map[id];
    else map[id] = mood;
    if (!writeMoods(map)) return false;
    document.dispatchEvent(new CustomEvent("theartfolio:moodchange", {
      detail: { id: id, mood: mood || null }
    }));
    return true;
  }

  window.TheArtfolioMoods = {
    list: MOODS,
    getMood: getMood,
    setMood: setMood,
    getAllMoods: getAllMoods
  };

  function moodLabel(id) {
    for (var i = 0; i < MOODS.length; i += 1) {
      if (MOODS[i].id === id) return MOODS[i].label;
    }
    return id;
  }

  function colourKey(value) {
    var key = String(value || "").trim().toLowerCase();
    if (key === "gray" || key === "grey") return "gray";
    if (key === "olive") return "sage";
    if (key === "turquoise") return "teal";
    if (key === "multi" || key === "multicolour") return "multicolor";
    if (key === "tan" || key === "clay") return "beige";
    return key;
  }

  function colourTokens(value) {
    return String(value || "")
      .toLowerCase()
      .split(/[,|\s]+/)
      .map(colourKey)
      .filter(Boolean);
  }

  /* ---------- Gallery mood + colour chip strips ---------- */
  function initGalleryMoodFilters() {
    var moodStrips = document.querySelectorAll("[data-mood-filter]");
    var colourStrips = document.querySelectorAll("[data-colour-filter]");
    if (!moodStrips.length && !colourStrips.length) return;

    function activeValue(strip, attr, fallback) {
      if (!strip) return fallback || "";
      var current = strip.querySelector(".is-active[" + attr + "]");
      var value = current ? current.getAttribute(attr) : fallback;
      if (!value || value === "all") return "";
      return value;
    }

    function apply(root) {
      var moodStrip = root.querySelector("[data-mood-filter]");
      var colourStrip = root.querySelector("[data-colour-filter]");
      var mood = activeValue(moodStrip, "data-mood-value");
      var colour = colourKey(activeValue(colourStrip, "data-colour-value"));
      var cards = root.querySelectorAll("[data-mood-card]");
      var shown = 0;
      cards.forEach(function (card) {
        var moods = (card.getAttribute("data-moods") || "").toLowerCase();
        var colours = colourTokens(card.getAttribute("data-colours"));
        var moodOk = !mood || moods.split(/\s+/).indexOf(mood) !== -1;
        var colourOk = !colour || colours.indexOf(colour) !== -1;
        var match = moodOk && colourOk;
        card.classList.toggle("is-mood-hidden", !match);
        if (match) shown += 1;
      });
      var empty = root.querySelector("[data-mood-empty]");
      if (empty) {
        empty.hidden = shown > 0 || (!mood && !colour);
        var hub = empty.querySelector("[data-filter-empty-hub]");
        if (hub) {
          var hubKey = mood || colour;
          if (hubKey) {
            var handle = hubKey === "grey" ? "gray" : hubKey;
            hub.href = "/collections/" + encodeURIComponent(handle + "-art-prints");
            hub.hidden = false;
          } else {
            hub.hidden = true;
          }
        }
      }
    }

    function bindStrip(strip, attr) {
      var scope = strip.closest(".coll-layout") || strip.closest(".coll-main") || document;
      strip.addEventListener("click", function (event) {
        var btn = event.target.closest("[" + attr + "]");
        if (!btn) return;
        strip.querySelectorAll("[" + attr + "]").forEach(function (el) {
          var on = el === btn;
          el.classList.toggle("is-active", on);
          el.setAttribute("aria-pressed", on ? "true" : "false");
        });
        var value = btn.getAttribute(attr) || "all";
        try {
          var url = new URL(window.location.href);
          var param = attr === "data-mood-value" ? "mood" : "colour";
          if (value && value !== "all") url.searchParams.set(param, value);
          else url.searchParams.delete(param);
          window.history.replaceState({}, "", url);
        } catch (error) { /* ignore */ }
        apply(scope);
      });
    }

    function syncFromUrl(strip, attr, initial) {
      if (!strip || !initial) return;
      strip.querySelectorAll("[" + attr + "]").forEach(function (btn) {
        var on = btn.getAttribute(attr) === initial;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    var params = new URLSearchParams(window.location.search);
    var initialMood = (params.get("mood") || "").toLowerCase();
    var initialColour = colourKey(params.get("colour") || params.get("color") || "");

    moodStrips.forEach(function (strip) {
      syncFromUrl(strip, "data-mood-value", initialMood);
      bindStrip(strip, "data-mood-value");
    });
    colourStrips.forEach(function (strip) {
      syncFromUrl(strip, "data-colour-value", initialColour);
      bindStrip(strip, "data-colour-value");
    });

    var firstStrip = moodStrips[0] || colourStrips[0];
    var firstScope = firstStrip
      ? (firstStrip.closest(".coll-layout") || firstStrip.closest(".coll-main") || document)
      : document;
    apply(firstScope);
  }

  /* ---------- PDP feel drawer ---------- */
  function initFeelDrawer() {
    var drawer = document.querySelector("[data-mood-feel-drawer]");
    var tab = document.querySelector("[data-mood-feel-tab]");
    if (!drawer || !tab) return;

    var backdrop = document.querySelector("[data-mood-feel-backdrop]");
    var closeBtn = drawer.querySelector("[data-mood-feel-close]");
    var status = drawer.querySelector("[data-mood-feel-status]");
    var clearBtn = drawer.querySelector("[data-mood-feel-clear]");
    var productId = cleanId(drawer.getAttribute("data-mood-product-id"));
    var lastFocus = null;

    function setOpen(open) {
      drawer.classList.toggle("is-open", open);
      drawer.hidden = !open;
      if (backdrop) {
        backdrop.hidden = !open;
      }
      tab.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.classList.toggle("mood-feel-lock", open);
      if (open) {
        lastFocus = document.activeElement;
        var recentSection = drawer.querySelector("[data-mood-recent]");
        var recentLink = drawer.querySelector("[data-mood-recent-link]");
        var first = recentSection && !recentSection.hidden && recentLink
          ? recentLink
          : drawer.querySelector("[data-mood-feel-option], [data-mood-feel-close]");
        if (first) first.focus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }

    function refresh() {
      var current = getMood(productId);
      drawer.querySelectorAll("[data-mood-feel-option]").forEach(function (btn) {
        var on = btn.getAttribute("data-mood-value") === current;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (status) {
        status.textContent = current
          ? "Saved as " + moodLabel(current) + " — just for you on this device."
          : "";
      }
      if (clearBtn) clearBtn.hidden = !current;

      var pill = document.querySelector("[data-mood-primary-pill]");
      if (pill) {
        var label = pill.querySelector("[data-mood-pill-label]");
        var defaultKey = pill.getAttribute("data-mood-default-key") || "";
        var defaultLabel = pill.getAttribute("data-mood-default-label") || "";
        var moodClasses = ["mood-pill--calm", "mood-pill--quiet", "mood-pill--soft", "mood-pill--warm", "mood-pill--vibrant", "mood-pill--energetic", "mood-pill--moody", "mood-pill--dramatic", "mood-pill--atmospheric", "mood-pill--nostalgic", "mood-pill--contemplative", "mood-pill--minimal", "mood-pill--felt"];
        moodClasses.forEach(function (cls) { pill.classList.remove(cls); });
        if (current) {
          pill.hidden = false;
          pill.classList.remove("mood-pill--swatches-only");
          pill.classList.add("mood-pill--" + current, "mood-pill--felt");
          if (label) label.textContent = "You felt · " + moodLabel(current);
        } else {
          if (defaultKey) pill.classList.add("mood-pill--" + defaultKey);
          if (label) label.textContent = defaultLabel;
          if (!defaultLabel && !defaultKey) {
            if (pill.querySelector(".mood-pill-swatches")) {
              pill.classList.add("mood-pill--swatches-only");
              pill.hidden = false;
            } else {
              pill.hidden = true;
            }
          } else {
            pill.hidden = false;
          }
        }
      }
    }

    tab.addEventListener("click", function () {
      setOpen(drawer.hidden || !drawer.classList.contains("is-open"));
    });
    if (closeBtn) closeBtn.addEventListener("click", function () { setOpen(false); });
    if (backdrop) backdrop.addEventListener("click", function () { setOpen(false); });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) setOpen(false);
    });

    drawer.addEventListener("click", function (event) {
      var option = event.target.closest("[data-mood-feel-option]");
      if (option) {
        var value = option.getAttribute("data-mood-value");
        var current = getMood(productId);
        setMood(productId, current === value ? null : value);
        refresh();
        return;
      }
      if (event.target.closest("[data-mood-feel-clear]")) {
        setMood(productId, null);
        refresh();
      }
    });

    document.addEventListener("theartfolio:moodchange", refresh);
    refresh();
    setOpen(false);
  }

  /* ---------- Homepage mood carousel: unique Liquid slides, JS clone for loop ---------- */
  function initMoodCarousels() {
    document.querySelectorAll("[data-mood-carousel]").forEach(function (section) {
      var track = section.querySelector("[data-mood-track]");
      var prev = section.querySelector("[data-mood-prev]");
      var next = section.querySelector("[data-mood-next]");
      if (!track || track.getAttribute("data-mood-bound") === "true") return;
      track.setAttribute("data-mood-bound", "true");

      var originals = Array.prototype.slice.call(
        track.querySelectorAll(".mood-carousel-slide:not([data-mood-clone])")
      );
      if (originals.length && !track.querySelector("[data-mood-clone]")) {
        originals.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute("data-mood-clone", "");
          clone.setAttribute("aria-hidden", "true");
          clone.setAttribute("inert", "");
          clone.removeAttribute("role");
          clone.querySelectorAll("[id]").forEach(function (el) {
            el.removeAttribute("id");
          });
          clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(function (el) {
            el.setAttribute("tabindex", "-1");
          });
          clone.querySelectorAll("img").forEach(function (img) {
            img.setAttribute("loading", "lazy");
            img.removeAttribute("fetchpriority");
          });
          track.appendChild(clone);
        });
      }

      function loopWidth() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        var width = 0;
        originals.forEach(function (slide) {
          width += slide.getBoundingClientRect().width;
        });
        if (originals.length > 1) width += gap * (originals.length - 1);
        return width;
      }

      function wrapScroll() {
        var loop = loopWidth();
        if (loop < 8) return;
        if (track.scrollLeft >= loop - 4) {
          track.scrollLeft = track.scrollLeft - loop;
        }
      }

      function scrollByDir(dir) {
        var amount = Math.max(240, Math.floor(track.clientWidth * 0.8));
        track.scrollBy({ left: dir * amount, behavior: "smooth" });
      }

      if (prev) prev.addEventListener("click", function () { scrollByDir(-1); });
      if (next) next.addEventListener("click", function () { scrollByDir(1); });
      if ("onscrollend" in track) {
        track.addEventListener("scrollend", wrapScroll, { passive: true });
      } else {
        track.addEventListener("scroll", function () {
          window.clearTimeout(track._moodWrapTimer);
          track._moodWrapTimer = window.setTimeout(wrapScroll, 120);
        }, { passive: true });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    storageUsable = testStorage();
    initGalleryMoodFilters();
    initFeelDrawer();
    initMoodCarousels();
  });
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector("[data-mood-carousel]")) {
      initMoodCarousels();
    }
  });
})();
